import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeRegisterFromRegime = api(({ registerId, regimeId }) =>
    mutate(
        gql`
            mutation RemoveRegisterFromRegime($registerId: String!, $regimeId: String!) {
                removeRegisterFromRegime(registerId: $registerId, regimeId: $regimeId)
            }
        `,
        { registerId, regimeId },
        { returns: "removeRegisterFromRegime" }
    )
)
